// Shared transport state, independent of React and MobX stores.
export const httpSession = { csrfToken: "" };
const unauthorizedListeners = new Set<() => void>();
export function onUnauthorized(listener: () => void) {
  unauthorizedListeners.add(listener);
  return () => { unauthorizedListeners.delete(listener); };
}
export function resetHttpSession(notify = false) {
  httpSession.csrfToken = "";
  if (notify) unauthorizedListeners.forEach(listener => listener());
}
